export function convertSecondsToHHMMSS(totalSec: string): string {
  const totalSeconds = Number(totalSec);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Pad hours, minutes, and seconds with leading zeros if they are less than 10
  const paddedHours = String(hours).padStart(2, '0');
  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}

export function convertDateTime(date: string): string {
  const tempDate = new Date(date);
  const day = String(tempDate.getDate()).padStart(2, "0");
  const month = String(tempDate.getMonth() + 1).padStart(2, "0");
  const year = String(tempDate.getFullYear() + 543).slice(-2);
  const hours = String(tempDate.getHours()).padStart(2, "0");
  const minutes = String(tempDate.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function getUniqueSpeakerList(transcriptList, includeAllSpeaker = true) {
  const uniqueSpeakers = transcriptList.map(item => item.role).filter((role, index, self) => self.indexOf(role) === index);
  return includeAllSpeaker ? ["All Speaker", ...uniqueSpeakers] : uniqueSpeakers;
}